import { dateFormat } from 'src/helpers';

export const minDate = dateFormat('12/01/2021');
